var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8145 7.33008L8.56445 11.5801C8.23242 11.9121 7.73438 11.9121 7.43555 11.5801L3.18555 7.33008C2.85352 7.03125 2.85352 6.5332 3.18555 6.23438C3.48438 5.90234 3.98242 5.90234 4.28125 6.23438L7.16992 9.12305L7.20312 0.921875C7.20312 0.490234 7.53516 0.125 8 0.125C8.43164 0.125 8.79688 0.490234 8.79688 0.921875V9.12305L11.6855 6.23438C11.9844 5.90234 12.4824 5.90234 12.7812 6.23438C13.1133 6.5332 13.1133 7.03125 12.7812 7.33008H12.8145ZM2.15625 11.5469V14.2031C2.15625 14.9668 2.7207 15.5312 3.48438 15.5312H12.5156C13.2461 15.5312 13.8438 14.9668 13.8438 14.2031V11.5469C13.8438 11.1152 14.1758 10.75 14.6406 10.75C15.0723 10.75 15.4375 11.1152 15.4375 11.5469V14.2031C15.4375 15.8301 14.1094 17.125 12.5156 17.125H3.48438C1.85742 17.125 0.5625 15.8301 0.5625 14.2031V11.5469C0.5625 11.1152 0.894531 10.75 1.35938 10.75C1.79102 10.75 2.15625 11.1152 2.15625 11.5469Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.e51e48b4e930d4f68ebf42c9314747db.svg";
export { ForwardRef as ReactComponent };